import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { imgClients } from "../../../assets/activityes/activityFour";
// import { GameFourSubtopicOne } from "./GameFourSubtopicOne";
import { GameTwoActovityFour } from "./GameTwoActovityFour";
import { useNavigate } from "react-router";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { tasksId } from "../../../types/activityTasks";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { RandomQuestion } from "../../../components/common/RandomQuestion";
import { shuffleArray } from "../../../helpers/questionRandom";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const clientGameOne = [
	{
		id: 0,
		title: "Leal",
		text: "Elige siempre nuestra Tienda. Nos esforzamos en brindar un servicio excelente.",
		img: imgClients.headleal,
	},
	{
		id: 1,
		title: "Tímido",
		text: "Generamos confianza para sus preguntas sobre promociones y productos.",
		img: imgClients.headtimido,
	},
	{
		id: 3,
		title: "Exigente",
		text: "Siempre estamos al tanto de promociones, servicios y productos para satisfacer tus necesidades.",
		img: imgClients.headexigente,
	},
	{
		id: 4,
		title: "Indeciso",
		text: "Los atendemos y asesoramos en su compra con consejos sobre nuestros productos.",
		img: imgClients.headindeciso,
	},
	{
		id: 5,
		title: "Impaciente",
		text: "Nos esforzamos por atenderlos eficientemente y rápidamente cumplir sus peticiones.",
		img: imgClients.headPaciente,
	},
	{
		id: 6,
		title: "Sociable",
		text: "Priorizamos un servicio eficiente y atender a todos sin retrasos.",
		img: imgClients.headSociable,
	},
	{
		id: 7,
		title: "Pasivo",
		text: "Ofrecemos un servicio eficiente y de calidad para su completa satisfacción.",
		img: imgClients.headPasivo,
	},
	// {
	// 	id: 8,
	// 	title: "Negociador",
	// 	text: "Estamos al tanto de precios y promociones para ofrecerles lo más conveniente. ",
	// 	img: imgClients.headNEgociador,
	// },
];

const clientsInfo = [
	{
		title: "Cliente Leal",
		img: imgClients.clientLeal,
		text: "El cliente leal elige siempre nuestra tienda. Nos esforzamos en brindar un servicio excelente.",
		actionVoices: () => { }
	},
	{
		title: "Cliente Exigente",
		img: imgClients.clientExigente,
		text: "Los clientes exigentes saben que esperar de nuestra tienda. Siempre estamos al tanto de promociones, servicios y productos para satisfacer tus necesidades.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a03)
		}
	},
	{
		title: "Cliente Indeciso",
		img: imgClients.clientindeciso,
		text: "Ayudamos a los clientes indecisos. Los atendemos y asesoramos en su compra con consejos sobre nuestros productos. Escucharlos y ser pacientes es primordial.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a04)
		}
	},
	{
		title: "Cliente Tímido",
		img: imgClients.clienttimido,
		text: "Comprendemos a los clientes tímidos. Creamos un ambiente de confianza para que se sientan cómodos al preguntar sobre promociones o productos.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a05)
		}
	},
	{
		title: "Cliente Impaciente",
		img: imgClients.clientimpaciente,
		text: "Comprendemos a los clientes impacientes. Nos esforzamos por atenderlos eficientemente y ser rápidos en cobrar o cumplir sus peticiones.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a06)
		}
	},
	{
		title: "Cliente Sociable",
		img: imgClients.clientsociable,
		text: "Valoramos a los clientes sociables. Priorizamos un servicio eficiente y atender a todos sin retrasos.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a07)
		}
	},
	{
		title: "Cliente Pasivo",
		img: imgClients.clientpasivo,
		text: "Nos preocupamos por los clientes pasivos. Ofrecemos un servicio eficiente y de calidad para su completa satisfacción.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a08)
		}
	},
	{
		title: "Cliente Negociador",
		img: imgClients.clientnegociador,
		text: "Apreciamos a los clientes negociadores. Estamos al tanto de precios y promociones para ofrecerles lo más conveniente. Ayudamos a tomar decisiones acertadas.",
		actionVoices: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a09)
		}
	},
];

const steps = {
	initialDialog: 1,
	insrucctions: 2,
	inforClients: 3,
	instructionsone: 4,
	activityOne: 5,
	winSubactivytiOne: 6,
	FailSubactivytiOne: 66,
	activityTwo: 7,
	winSubactivityTwo: 8,
	FailSubactivityTwo: 9,
	viewActivities: 10,
};

let numberSumPoint = 0

export const SubtopicOneActivityFive = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(steps.initialDialog);
	const [clientInfoPage, setClientInfoPage] = useState(0);
	const [questionGameOne, setQuestionGameOne] = useState([]);
	const [responseQuestionGameOne, setResponseQuestionGameOne] = useState([]);
	const [numberQuestion, setNumberQuestion] = useState(0);
	const [saveResponsesGameOne, setSaveResponsesGameOne] = useState([]);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema1.activities.subtema1], 5);

	useEffect(() => {
		if (loaded) {
			console.log("subtema one Activity one");
			ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a01)
	})

	const getRandomQuestionGameOne = useCallback(() => {
		const newQuestion = shuffleArray(clientGameOne);
		const questions = newQuestion.slice(0, 5);
		const newResponse = shuffleArray(questions);
		setQuestionGameOne(questions);
		setResponseQuestionGameOne(newResponse);
	}, []);

	useEffect(() => {
		getRandomQuestionGameOne();
	}, [getRandomQuestionGameOne]);

	const condition = (client) => client.id === questionGameOne[numberQuestion + 1].id;

	const checkCorrectsInGameOne = (array = []) => {
		const trueElements = array.filter(element => element === true);
		return trueElements.length >= 3;
	}

	const verificationResponse = (selectNumber = -1) => {
		if (selectNumber === -1) {
			return;
		}

		if (numberQuestion + 1 >= questionGameOne.length + 1) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveResponsesGameOne)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* verificar si es correcto
		const isCorrectResponse = questionGameOne[numberQuestion].id === selectNumber;
		const saveGame = [...saveResponsesGameOne, isCorrectResponse];

		if (numberQuestion + 1 === questionGameOne.length) {
			const resultadoThreeWin = checkCorrectsInGameOne(saveGame)
			finishSubactivityOne(resultadoThreeWin);
			return;
		}

		//* revolver respuestas
		const matchingObject = clientGameOne.find(condition);
		const nonMatchingObjects = clientGameOne.filter((client) => !condition(client));
		const shuffleNonMatchingObjects = shuffleArray(nonMatchingObjects);
		const sliceNonMatchingObjects = shuffleNonMatchingObjects.slice(0, 4);
		sliceNonMatchingObjects.push(matchingObject);
		const shuffleNewResponse = shuffleArray(sliceNonMatchingObjects);
		//* guardar state
		setResponseQuestionGameOne(shuffleNewResponse);
		setNumberQuestion(numberQuestion + 1);
		setSaveResponsesGameOne(saveGame);
	};

	const finishSubactivityTwo = (points) => {
		if (points === 3) {
			setUiToShow(steps.winSubactivityTwo);
		} else {
			setUiToShow(steps.FailSubactivityTwo);
		}
	};

	const finishSubactivityOne = (isWin = false) => {
		if (isWin) {
			setUiToShow(steps.winSubactivytiOne);
		} else {
			setUiToShow(steps.FailSubactivytiOne);
		}
	};

	useEffect(() => {
		if ([steps.activityOne].includes(uiToShow)) {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.activityScene)
		}
	}, [uiToShow])

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />

				{![1, -1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.subtopicOne.initScene, 5);
						setUiToShow(1)
						setClientInfoPage(0)
						getRandomQuestionGameOne()
						setNumberQuestion(0)
						setSaveResponsesGameOne([])
						numberSumPoint = 0
					}} />
				)}
			</>
			{uiToShow === steps.initialDialog && (
				<>
					<HeaderRedPresentation name="Actividad 5: Tipos de clientes." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={
							"¡Vas excelente!, recuerda prestar atención a los detalles, habrá diferencias entre clientes y tiendas por lo que debemos estar siempre preparados para dar el mejor servicio posible."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.viewActivities);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{/* {uiToShow === steps.insrucctions && (
				<DialogBarNew
					titulo="Datti Andatti"
					dialog={"Descubre e identifica los tipos de Clientes que se pueden presentar en las Tiendas y ofrecerles asi un mejor servicio."}
					callback={() => {
						setUiToShow(steps.viewActivities);
						ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
					}}
					percentage={"50%"}
				></DialogBarNew>
			)} */}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Imagen en la tienda."
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a02)
							setUiToShow(steps.inforClients);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.inforClients && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 h-full w-full pt-12 flex justify-center items-center">
						<div className="w-[176px] h-[220px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
							<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
								<p className="text-white text-[10px] md:text-[16px]">{clientsInfo[clientInfoPage].title}</p>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
								<div className="w-full h-full py-3">
									<img className="h-full w-full object-contain" src={clientsInfo[clientInfoPage].img} alt="client" />
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={clientsInfo[clientInfoPage].text}
						callback={() => {
							if (clientInfoPage <= 6) {
								clientsInfo[clientInfoPage + 1].actionVoices()
								setClientInfoPage(clientInfoPage + 1);
							} else {
								ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T1.sub01.sub1_act5_a10)
								setUiToShow(steps.instructionsone);
								ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							}
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.instructionsone && (
				<>
					<HeaderRedPresentation name="Ejercicio: Relaciona las columnas." />
					<DialogBarNew
						titulo="Datti Andatti"
						dialog={"Es hora de aplicar lo aprendido, relaciona las columnas de los Clientes con sus respectivas características."}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.activityOne);
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
						}}
						percentage={"50%"}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.activityOne && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<BarStatusActivies activities={tasksList} />
					<RandomQuestion
						action={verificationResponse}
						numberQuestion={numberQuestion}
						arrayQuestion={questionGameOne}
						anserwerQuestion={responseQuestionGameOne}
					/>
				</>
			)}
			{uiToShow === steps.winSubactivytiOne && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={15}
					dialogModal="Tu habilidad para reconocer las necesidades y preferencias de cada uno de ellos será de gran ayuda."
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						numberSumPoint += 15
						setUiToShow(steps.activityTwo);
					}}
				/>
			)}
			{uiToShow === steps.FailSubactivytiOne && (
				<ValidationResultModal
					title="Respuesta incorrecta."
					dialogModal="Recuerda que reconocer los diferentes tipos de clientes te ayudará a ser mas eficiente y a evitar conflictos."
					buttonTxt="Continuar"
					isCorrect={false}
					action={() => {
						numberSumPoint += 5
						setUiToShow(steps.activityTwo);
					}}
				/>
			)}

			{uiToShow === steps.activityTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<GameTwoActovityFour
						calllbackWin={(points) => {
							finishSubactivityTwo(points);
						}}
					></GameTwoActovityFour>
				</>
			)}
			{uiToShow === steps.winSubactivityTwo && (
				<ValidationResultModal
					title="¡Bien hecho!"
					numberPoints={15}
					dialogModal="¡Lograste identificar correctamente los diferentes tipos de clientes!"
					buttonTxt="Continuar"
					isCorrect={true}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 5,
								pointsWin: numberSumPoint + 15,
								subtema: tasksId.tema1.activities.subtema1,
							})
						);
						navigate("/home1/tema1/subtema1/activityresult");
					}}
				/>
			)}
			{uiToShow === steps.FailSubactivityTwo && (
				<ValidationResultModal
					title="Respuesta incorrecta."
					dialogModal="Reconocer los diferentes tipos de clientes te ayudará a ser mas eficiente y a evitar conflictos."
					buttonTxt="Continuar"
					isCorrect={false}
					action={() => {
						dispatch(
							completeOneTask({
								idActivity: 5,
								pointsWin: numberSumPoint + 5,
								subtema: tasksId.tema1.activities.subtema1,
							})
						);
						navigate("/home1/tema1/subtema1/activityresult");
					}}
				/>
			)}
		</>
	);
};
